import { LAYER_A_GRID_H, LAYER_A_GRID_W, TILE_SIZE } from "@cold-case/shared/constants";

const DESIGN_SCALE = 5 / 3;
export const DESIGN_WIDTH = Math.round(960 * DESIGN_SCALE);
export const DESIGN_HEIGHT = Math.round(540 * DESIGN_SCALE);
/** Playfield px — must match `LAYER_A_GRID_*` × `TILE_SIZE` (see `map-world-dims.ts`). */
export const WORLD_WIDTH = LAYER_A_GRID_W * TILE_SIZE;
export const WORLD_HEIGHT = LAYER_A_GRID_H * TILE_SIZE;
/** Camera follow smoothing; lower = smoother but lazier tracking. */
export const RUN_CAMERA_FOLLOW_LERP_X = 0.1;
export const RUN_CAMERA_FOLLOW_LERP_Y = 0.1;
/** After a zone transition, follow uses this briefly so scroll does not snap-jolt. */
export const RUN_CAMERA_FOLLOW_LERP_SOFT = 0.04;
export const RUN_MAIN_CAMERA_ZOOM = 1;
/**
 * Shared run speed (px/s) for keyboard and pointer — tuned so crossing the world (~3.6× design)
 * feels like a brisk walk (~10–20s) instead of a crawl.
 */
export const RUN_PLAYER_SPEED_PX_S = 240;
export const PLAYFIELD_WALK_STEER_HOLD_MS = 100;
